<template>
  <div class="culture">
    <div class="banner"></div>
    <div class="culturecontent">
      <div class="navs">
        <navlist :navlist="navlist" @returnpath="returnpath" />
      </div>
      <div class="miancontent">
        <surveyintro v-if="navindex == 0" />
        <surveyframework v-if="navindex == 1" />
        <surveylayout v-if="navindex == 2" />
        <surveyqualify v-if="navindex == 3" />
        <surveyhonor v-if="navindex == 4" />
      </div>
    </div>
  </div>
</template>

<script>
import navlist from "./commonnavs.vue";
import surveyintro from "./surveyintro.vue"; //企业简介
import surveyframework from "./surveyframework.vue"; //组织架构
import surveylayout from "./surveylayout.vue"; //市场布局
import surveyqualify from "./surveyqualify.vue"; //企业资质
import surveyhonor from "./surveyhonor.vue"; //企业荣誉
export default {
  components: {
    navlist,
    surveyqualify,
    surveylayout,
    surveyintro,
    surveyframework,
    surveyhonor,
  },
  data() {
    return {
      navlist: {
        name: "企业概况",
        list: [
          { name: "企业简介", index: 0 },
          // { name: "组织架构", index: 1 },
          { name: "市场布局", index: 2 },
          { name: "企业资质", index: 3 },
          { name: "企业荣誉", index: 4 },
        ],
      },
      navindex: 0,
    };
  },
  methods: {
    returnpath(e) {
      this.navindex = e;
    },
  },
  watch: {
    $route(to, from) {
      if (to.query.index) {
        this.navindex = to.query.index;
        console.log(this.navindex);
      }
    },
  },
};
</script>

<style scoped lang="less">
.culture {
  .culturecontent {
    .miancontent {
      background: #fff;
      flex: 1;
      width: 61.25vw;
    }
    .navs {
      width: 10.42vw;
      height: 21.88vw;
      margin-right: 1.25vw;
    }
    width: 100%;
    padding: 2.08vw 13.54vw 5.21vw 13.54vw;
    display: flex;
  }
  .banner {
    width: 100%;
    height: 26.04vw;
    //background: url("https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/banner/bannerqykgtop.png") no-repeat;
    background: url("https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/bannerqykgtop.png") no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
  }
  width: 100%;
  background: rgba(240, 242, 246, 1);
}
</style>
